/*
@davidrocha:
While this enum extends MetricEventTypes, directly modifying the latter could lead to unintended changes. Although this approach isn't optimal, it offers a cleaner and more scalable solution than altering the usage of MetricEventTypes throughout the codebase
*/

enum MetricFilterTypes {
  BYB_IQ = "BYB_IQ",
  GAMEPLAY_DURATION = "GAMEPLAY_DURATION",
  SCAN_FREQUENCY = "SCAN_FREQUENCY",
  SCAN_TIMING = "SCAN_TIMING",
  CRITICAL_SCAN = "CRITICAL_SCAN",
  AWARENESS = "AWARENESS",
  DECISION = "DECISION",
}

export default MetricFilterTypes;
